import { reactive } from 'vue';
import { fetchBacklogConfigurations } from '@/services/fetchBacklogConfigurations';
import { BacklogConfigurationsApiResp } from '@/pages/OperationsInsights/types/BacklogConfigurationResponse';

type backlogConfigStore = {
    data: BacklogConfigurationsApiResp | null;
}

type backlogNamesStore = {
    data: string[];
}

export const useBacklogConfigurationsStore = () => {
    const backlogConfigurationsStore = reactive<backlogConfigStore>({ data: null });

    const ageBandConfigNamesStore = reactive<backlogNamesStore>({ data: [] });

    fetchBacklogConfigurations().then((configurations) => {
        backlogConfigurationsStore.data = configurations;
        ageBandConfigNamesStore.data = [
            ...configurations.globalConfig.ageBandConfig.items.map((i) => i.name),
            configurations.globalConfig.ageBandConfig.defaultAgeBand
        ];
    });

    return { backlogConfigurationsStore, ageBandConfigNamesStore };
};